/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Ebook_PdfInputs */

const en_val_ebook_pdf = /** @type {(inputs: Val_Ebook_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eBook (PDF)`)
};

const es_val_ebook_pdf = /** @type {(inputs: Val_Ebook_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eBook / PDF`)
};

const fr_val_ebook_pdf = /** @type {(inputs: Val_Ebook_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eBook / PDF`)
};

const de_val_ebook_pdf = /** @type {(inputs: Val_Ebook_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eBook / PDF`)
};

const ja_val_ebook_pdf = /** @type {(inputs: Val_Ebook_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電子書籍 / PDF`)
};

const zh_val_ebook_pdf = /** @type {(inputs: Val_Ebook_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电子书 / PDF`)
};

const ar_val_ebook_pdf = /** @type {(inputs: Val_Ebook_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كتاب إلكتروني / PDF`)
};

const id_val_ebook_pdf = /** @type {(inputs: Val_Ebook_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eBook / PDF`)
};

const it_val_ebook_pdf = /** @type {(inputs: Val_Ebook_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eBook / PDF`)
};

const ru_val_ebook_pdf = /** @type {(inputs: Val_Ebook_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Электронная книга / PDF`)
};

const pt_val_ebook_pdf = /** @type {(inputs: Val_Ebook_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eBook / PDF`)
};

const ko_val_ebook_pdf = /** @type {(inputs: Val_Ebook_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전자책(eBook) / PDF`)
};

/**
* | output |
* | --- |
* | "eBook (PDF)" |
*
* @param {Val_Ebook_PdfInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_ebook_pdf = /** @type {((inputs?: Val_Ebook_PdfInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Ebook_PdfInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_ebook_pdf(inputs)
	if (locale === "es") return es_val_ebook_pdf(inputs)
	if (locale === "fr") return fr_val_ebook_pdf(inputs)
	if (locale === "de") return de_val_ebook_pdf(inputs)
	if (locale === "ja") return ja_val_ebook_pdf(inputs)
	if (locale === "zh") return zh_val_ebook_pdf(inputs)
	if (locale === "ar") return ar_val_ebook_pdf(inputs)
	if (locale === "id") return id_val_ebook_pdf(inputs)
	if (locale === "it") return it_val_ebook_pdf(inputs)
	if (locale === "ru") return ru_val_ebook_pdf(inputs)
	if (locale === "pt") return pt_val_ebook_pdf(inputs)
	return ko_val_ebook_pdf(inputs)
});